module.exports = __webpack_public_path__ + "media/images/lb/282-a9ca46defa77c7e6f55258bb9b0aa8dd.svg";